<template>
  <AudioPlayer :src="url" @ended="$emit('ended')" />
</template>

<script lang="ts">
import { isUndefined } from 'ramda-adjunct'
import { computed, defineComponent, type PropType } from 'vue'

import { type Question } from '../../models/Question'
import AudioPlayer from '../dumb/AudioPlayer.vue'

export default defineComponent({
  components: { AudioPlayer },
  props: {
    question: {
      type: Object as PropType<Pick<Question, 'media'>>,
      required: true,
    },
  },
  emits: {
    ended: () => true,
  },
  setup(props) {
    const url = computed(() => {
      if (isUndefined(props.question.media))
        throw new Error('expect currentQuestion.media to be defined')
      if (props.question.media.type !== 'audio') throw new Error('expected media type to be audio')
      return props.question.media.url
    })

    return { url }
  },
})
</script>
